/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { Typography } from "@mui/material";

export function SidebarLinks(props) {
  let location = useLocation();
  const { routes } = props;

  const [isDark, setIsDark] = React.useState(
    document.documentElement.classList.contains("dark")
  );

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const getActiveStyle = () => {
    if (isDark) {
      return {
        background: "linear-gradient(135deg, rgba(244,63,94,0.25) 0%, rgba(236,72,153,0.15) 100%)",
        boxShadow: "0 4px 20px 0 rgba(244,63,94,0.4), inset 0 0 0 1px rgba(244,63,94,0.3)",
        borderRadius: "12px",
      };
    }
    return {
      background: "linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)",
      boxShadow: "0 6px 20px 0 rgba(244,63,94,0.45)",
      borderRadius: "12px",
    };
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        const isActive = activeRoute(route.path);
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div
              className="relative mb-2 flex hover:cursor-pointer mx-2 transition-all duration-300"
              style={isActive ? getActiveStyle() : {}}
            >
              <li
                className="my-[3px] flex cursor-pointer items-center pl-2 w-full"
                key={index}
              >
                <span
                  style={{
                    color: isActive
                      ? (isDark ? "#fb7185" : "#ffffff")
                      : (isDark ? "#f472b6" : "#f472b6"),
                  }}
                  className="pr-2"
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <Typography
                  variant="h6"
                  style={{
                    color: isActive
                      ? (isDark ? "#fda4af" : "#ffffff")
                      : (isDark ? "#f472b6" : "#f472b6"),
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: isActive ? 600 : 400,
                    fontSize: "0.875rem",
                    letterSpacing: isActive ? "0.08em" : "0.05em",
                    textTransform: "uppercase",
                  }}
                  className="leading-1 ml-5 flex"
                >
                  {route.name}
                </Typography>
              </li>
            </div>
          </Link>
        );
      }
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
